import { Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Header from '@components/layout/Header'
import Footer from '@components/layout/Footer'
import PageLoader from '@components/ui/PageLoader'

// Lazy-load pages for code splitting
const Home        = lazy(() => import('@pages/Home'))
const Services    = lazy(() => import('@pages/Services'))
const ServiceDetail = lazy(() => import('@pages/ServiceDetail'))
const Contact     = lazy(() => import('@pages/Contact'))
const BrandManifesto = lazy(() => import('@pages/BrandManifesto'))
const NotFound    = lazy(() => import('@pages/NotFound'))
const PillarPage  = lazy(() => import('@pages/PillarPage'))
const Blog        = lazy(() => import('@pages/blog/Blog'))
const BlogPost    = lazy(() => import('@pages/blog/BlogPost'))

/**
 * App — root router + layout shell
 *
 * Architecture note:
 * - All routes are lazy-loaded for optimal bundle splitting
 * - Header / Footer persist across routes (no re-mount flash)
 * - Suspense boundary shows <PageLoader /> during chunk loads
 * - Future Agentic AI pages can be dropped in as new <Route> entries
 */
export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-dark-950">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/"                    element={<Home />} />
            <Route path="/services"            element={<Services />} />
            <Route path="/services/:slug"      element={<ServiceDetail />} />
            <Route path="/contact"             element={<Contact />} />
            <Route path="/brand-manifesto"     element={<BrandManifesto />} />
            <Route path="/answer-engine-optimization-services"    element={<PillarPage pageKey="aeo" />} />
            <Route path="/generative-engine-optimization-services" element={<PillarPage pageKey="geo" />} />
            <Route path="/ai-visibility-audit"                      element={<PillarPage pageKey="audit" />} />
            <Route path="/mcp-powered-marketing"                    element={<PillarPage pageKey="mcp" />} />
            <Route path="/paid-advertising-ppc-chatgpt-ads"         element={<PillarPage pageKey="paidMedia" />} />
            <Route path="/guides/aeo-vs-geo-vs-seo"                 element={<PillarPage pageKey="guide" />} />
            <Route path="/blog"                                     element={<Blog />} />
            <Route path="/blog/:slug"                               element={<BlogPost />} />
            {/* Future routes — uncomment as you build them
            <Route path="/about"               element={<About />} />
            <Route path="/ai-solutions"        element={<AISolutions />} />
            <Route path="/mcp-integration"     element={<MCPIntegration />} />
            */}
            <Route path="*"                    element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  )
}

